import { getUserInfo, getUserInfoInApp } from '@/api/user'

const user = {
  state: {
    userInfo: null,
  },
  mutations: {
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo
    }
  },
  actions: {
    GetUserInfo({ commit, state }) { // 家长端获取用户信息
      return new Promise((resolve, reject) => {
        if(state.userInfo) {
          resolve(state.userInfo)
        } else {
          getUserInfo().then(res => {
            commit('SET_USERINFO', res.data)
            resolve(res.data)
          }).catch(error => {
            reject(error)
          })
        }
      })
    },
    GetUserInfoInApp({ commit, state }, user_id) { // app内获取用户信息
      return new Promise((resolve, reject) => {
        if(state.userInfo) {
          resolve(state.userInfo)
        } else {
          getUserInfoInApp({
            user_id
          }).then(res => {
            commit('SET_USERINFO', res.data)
            resolve(res.data)
          }).catch(error => {
            reject(error)
          })
        }
      })
    },
    UpdateUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          commit('SET_USERINFO', res.data)
          resolve(res.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    LogOut({ commit }) {
      localStorage.removeItem('token')
      commit('SET_USERINFO', null)
    } 
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js